import React from "react";
import ApprovalProcess from "./CreateApproval";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { BackButton } from "../../../../Components/Utils/Buttons";

const modules = [
    "survey_report",
    'inspection',
    'tc',
    'refilling',
    
    "invoice_outgoing",
    "quotation",
   

    
];

const NewApprovalIndex = () => {
  return (
    <div className="w-full h-full px-4 py-2">
      <div className="w-full flex justify-between items-center">
        <Breadcrumb
          items={[
            { name: "Settings" },
            { name: "Approval Status" },
          ]}
        />
        <BackButton />
      </div>

      <div className="w-full h-[calc(100vh-145px)]  mt-3 mx-auto rounded-md overflow-y-scroll">
 {/* <div className="sticky top-0 z-10 bg-gray-50 p-4 border-b border-slate-200">
    <p className="pb-2 py-3 px-2 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Approval Status :
                </p>
  </div> */}
        {modules.map((mod) => (
          <div key={mod} className="p-3">
            <ApprovalProcess moduleName={mod} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewApprovalIndex;
